/** @jsxImportSource @emotion/react */
import React from 'react';
import Select, {Props, StylesConfig} from 'react-select';
import {hexToRgba} from 'utils';

export enum SelectSizes {
  sm = '27px',
  md = '35px',
}
export default React.forwardRef<HTMLInputElement, Props>((props, ref) => {
  const customStyles = props.customStyles || {};
  const defaultSize = (props.size || 'md') as keyof typeof SelectSizes

  const _customStyles: StylesConfig<any, false, any> = {
    ...customStyles,
    control: (styles, {isDisabled, isFocused}) => ({
      ...styles,
      backgroundColor: (isDisabled && hexToRgba('#F9F9F9', '.3')) || '#F9F9F9',
      borderRadius: '2px',
      minHeight: SelectSizes[defaultSize],
      cursor: 'pointer',
      boxShadow: isFocused
        ? props.error
          ? `0 0 3px 0 #ff3b30`
          : isDisabled
          ? 'none'
          : `0 0 3px 0 #26ABE3`
        : 'none',
      borderColor: props.error
        ? '#ff3b30'
        : isDisabled
        ? hexToRgba('#d5dadd', '.3')
        : isFocused
        ? '#26ABE3'
        : '#d5dadd',

      ':hover': {
        borderColor: props.error
          ? '#ff3b30'
          : isDisabled
          ? hexToRgba('#d5dadd', '.3')
          : '#26ABE3',
      },
    }),
    valueContainer: styles => ({ ...styles, minHeight: SelectSizes[defaultSize] }),
    dropdownIndicator: styles => ({ ...styles, padding: 0, paddingRight: '8px' }),
    indicatorSeparator: styles => ({ ...styles, width: 0 }),
    input: styles => ({...styles}),
    placeholder: styles => ({...styles}),
    singleValue: (styles) => ({...styles}),
    option: styles => ({...styles, cursor: 'pointer' }),
  };

  return (
    <div css={{display: 'flex', flexDirection: 'column'}}>
      <Select
        {...props}
        closeMenuOnSelect={props.isMulti ? false : true}
        styles={_customStyles}
        height={27}
        inputRef={ref}
        placeholder={props.placeholder || ''}
      />
      <p css={{color: '#ff3b30', margin: 0}}>
        {typeof props.error === 'object' ? props.error.message : props.error}
      </p>
    </div>
  );
});
